import React from 'react';
import { UnoComponent } from './../../core';

@UnoComponent({id:'Empty'})
export class Empty extends React.Component<any, any> {
    render() {
        return (<></>);
    }
}